import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(t('footer.newsletter.button'));
    setEmail('');
  };

  return (
    <footer className="bg-gray-900 text-white mx-6 mb-6 rounded-3xl overflow-hidden">
      <div className="max-w-7xl mx-auto px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/24aeac95850e55fcda9f6af40f64c6a6/5533c6b9721b42fabcee3c27bfcaba87.png"
              alt="Yamauchi Partners"
              className="h-12 w-auto object-contain mb-6"
            />
            <h3 className="text-4xl font-light mb-2">
              {t('footer.newsletter.title1')}
            </h3>
            <h3 className="text-4xl font-light mb-6">
              {t('footer.newsletter.title2')}
            </h3>
            <p className="text-sm text-gray-400 mb-8">
              {t('footer.newsletter.desc')}
            </p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('footer.newsletter.placeholder')}
                className="w-full bg-transparent border-b border-gray-600 py-3 text-sm focus:outline-none focus:border-white transition-colors"
                required
              />
              <button
                type="submit"
                className="bg-white text-gray-900 px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                {t('footer.newsletter.button')} →
              </button>
            </form>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-6">
              {t('footer.services.title')}
            </h4>
            <ul className="space-y-4">
              <li>
                <a href="#services" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  {t('footer.services.consulting')}
                </a>
              </li>
              <li>
                <a href="#travel" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  {t('footer.services.travel')}
                </a>
              </li>
              <li>
                <a href="#school" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  {t('footer.services.school')}
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  {t('footer.services.ai')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-6">
              {t('footer.contact.title')}
            </h4>
            <div className="space-y-3 mb-8">
              <p className="text-sm text-gray-300">{t('footer.contact.phone')}</p>
              <p className="text-sm text-gray-300">{t('footer.contact.email')}</p>
            </div>
            <h4 className="text-sm font-semibold mb-4">
              {t('footer.contact.address')}
            </h4>
            <p className="text-sm text-gray-300">{t('footer.contact.location1')}</p>
            <p className="text-sm text-gray-300">{t('footer.contact.location2')}</p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex gap-6">
            <a href="#" className="text-sm text-gray-400 hover:text-white underline transition-colors cursor-pointer">
              {t('footer.social.linkedin')}
            </a>
            <a href="#" className="text-sm text-gray-400 hover:text-white underline transition-colors cursor-pointer">
              {t('footer.social.facebook')}
            </a>
            <a href="#" className="text-sm text-gray-400 hover:text-white underline transition-colors cursor-pointer">
              {t('footer.social.instagram')}
            </a>
          </div>

          <p className="text-sm text-gray-400">{t('footer.copyright')}</p>

          <div className="flex gap-6">
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
              {t('footer.terms')}
            </a>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              {t('footer.poweredBy')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
